import MenuList from "./MenuList"

const Menu = () => {
  return (
    <>
      <div className={'header-navigation-area default-bg'}>
        <div className={'container-fluid px-5'}>
          <div className={'row'}>
            <div className={'col-lg-12'}>
              <div className={'header-navigation header-navigation--header-default position-relative'}>
                <div className={'header-navigation__nav position-static'}>
                  <nav>
                    <ul>
                      <MenuList />
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Menu